export {Animation, Animation as default} from './animation.component';
export type {Props} from './animation.component';
